import { useMemo } from 'react';
import { FilterEntry } from '../components/EntityFilterPicker';

/**
 * Shared because the report and both logs must encode a slice identically — when they
 * disagreed, a row's report and its log answered different questions. One value per
 * field is a scalar, several an array, matching how buildWhere reads them.
 */
export function useFilterParams(filters: FilterEntry[]) {
    const filterParams = useMemo(() => {
        const byField: Record<string, string[]> = {};
        for (const f of filters) (byField[f.field] ||= []).push(f.value);
        const out: Record<string, string | string[]> = {};
        for (const [field, vals] of Object.entries(byField)) out[field] = vals.length > 1 ? vals : vals[0];
        return out;
    }, [filters]);

    const filtersKey = useMemo(
        () => filters.map(f => `${f.field}:${f.value}`).sort().join(','),
        [filters],
    );

    return { filterParams, filtersKey };
}
